// Tab Endereço (leitura nesta onda).
import { useTranslation } from "react-i18next"

import type { AdminMerchant } from "@/types/admin-merchant"

import { formatZipcode } from "../utils"
import { ReadOnlyField } from "./read-only-field"

const panelPrefix = "pages.adminMerchants"

type MerchantAddressTabProps = {
  merchant: AdminMerchant
}

export const MerchantAddressTab = ({
  merchant,
}: MerchantAddressTabProps) => {
  const { t } = useTranslation()
  const address = merchant.address

  if (!address) {
    return (
      <div
        data-testid="merchant-address-empty"
        className="flex flex-col items-center gap-2 rounded-xl border border-dashed px-6 py-14 text-center"
      >
        <p className="text-sm text-muted-foreground">
          {t(`${panelPrefix}.address.empty`)}
        </p>
      </div>
    )
  }

  return (
    <section className="rounded-xl border bg-card p-4 shadow-sm">
      <div className="grid grid-cols-1 gap-4 @2xl:grid-cols-2 @5xl:grid-cols-3">
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.zipcode`)}
          value={formatZipcode(address.zipcode)}
          mono
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.street`)}
          value={address.street}
          className="@5xl:col-span-2"
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.number`)}
          value={address.number}
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.complement`)}
          value={address.complement}
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.neighborhood`)}
          value={address.neighborhood}
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.city`)}
          value={address.city}
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.state`)}
          value={address.state}
        />
        <ReadOnlyField
          label={t(`${panelPrefix}.fields.country`)}
          value={address.country}
        />
      </div>
    </section>
  )
}
